<template>
	<v-row>
		<v-col :cols="hasButton ? false : 'auto'">
			<a v-if="anchor" class="anchor" :id="anchor"></a>
			<component
				:is="tag"
				class="mb-3 mt-n1"
				:class="titleClass"
			>
				{{ title }}
			</component>
			<template v-if="hasContent && contentTag">
				<slot></slot>
			</template>
			<template v-else>
				<p v-if="hasContent">
					<slot></slot>
				</p>
			</template>
		</v-col>
		<template v-if="hasButton">
			<v-col class="mt-n2" cols="auto">
				<slot name="button"></slot>
			</v-col>
		</template>
		<template v-if="caption">
			<v-col class="mt-n4 pt-0" cols="12">
				<p class="caption">{{ caption }}</p>
			</v-col>
		</template>
	</v-row>
</template>

<script>
export default {
	name: 'FormTitle',
	props: {
		anchor: [String, Boolean],
		caption: {
			type: String,
			default: ''
		},
		tag: {
			type: String,
			default: 'h5'
		},
		title: {
			type: String,
			default: 'Form Title'
		},
		titleClass: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			contentTag: undefined,
			hasButton: false,
			hasContent: false
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.hasButton = !!this.$slots?.button;
			this.hasContent = !!this.$slots?.default;
			this.contentTag = this.$slots?.default?.[0]?.tag;
		});
	}
};
</script>

<style lang="scss" scoped>
a.anchor {
	display: block;
	font-size: 0.05px;
	height: 1px;
	margin-bottom: -1px;
	position: relative;
	top: -32px;
	width: 1px;
}
</style>

